import React from "react";
import { MdCardGiftcard } from "react-icons/md";
import { useSelector } from "react-redux";
import { State } from "../../../store";
import CardBalance from "../../MyAccount/AccountCard/CardBalance";
import useFinalizeManager from "../hooks/useFinalizeManager";
import "./style.scss";
import { useTranslation } from "react-i18next";

interface IProps {
  handleSetPayment: (type: string) => void;
}

const EcardButton: React.FC<IProps> = ({ handleSetPayment }: IProps) => {
  const saleConfiguration = useSelector((state: State) => state.config.configuration);
  const { calculateEcard } = useFinalizeManager();
  const { t } = useTranslation();

  return (
    <React.Fragment>
      {saleConfiguration.ecard_PayByEcard && (
        <React.Fragment>
          <p className="or">{t("lub")}</p>
          <div className="ecard">
            <div className="button button-ecard button-outline-main flex-between-center">
              <div className="flex-start-center">
                <MdCardGiftcard className="big-icon" />
                <div className="ecard-text">
                  <b>
                    {t("zaplac")} {saleConfiguration.giftCard3Message}
                  </b>
                  <span className="flex-column flex-start">
                    {t("dostepne_srodki")}:
                    <CardBalance />
                  </span>
                </div>
              </div>
              <button
                onClick={() => {
                  handleSetPayment("ecard");
                  calculateEcard();
                }}
                className="button medium padding-medium button-fill-main move-up"
              >
                {t("wybierz")}
              </button>
            </div>
          </div>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default EcardButton;
